import { render, staticRenderFns } from "./getDownloadView.vue?vue&type=template&id=c6b0b064&scoped=true"
import script from "./getDownloadView.vue?vue&type=script&lang=js"
export * from "./getDownloadView.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b0b064",
  null
  
)

export default component.exports